import env from "../../../../config/env";
import { AxiosInstance } from "axios";
import { action, makeAutoObservable } from "mobx";
import http from "../../../../services/http";
import { ServiceResult } from "../../../../types/general-types";

import qs from "qs";
import {
  ChangePasswordRequestDto,
  SendChangePasswordLinkRequestDto,
  SendChangePasswordLinkResponseDto,
  SendChangePasswordVerificationCodeResponseDto,
} from "./types";
const { API_BASE_URL } = env;

class AccountActionStore {
  static readonly id: string = "AccountActionStore";
  readonly _apiBaseURL: string = "account-action";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }

  @action.bound async ChangePasswordCheckUsername(
    params: SendChangePasswordLinkRequestDto
  ) {
    const q = qs.stringify(params, {
      encodeValuesOnly: true,
      addQueryPrefix: true,
    });
    const response: ServiceResult<SendChangePasswordLinkResponseDto> = await (
      await this.api.get(
        `/${this._apiBaseURL}/change-password-check-username${q}`
      )
    ).data;
    return response;
  }

  @action.bound async SendChangePasswordLink(
    params: SendChangePasswordLinkRequestDto
  ) {
    const response: ServiceResult = await (
      await this.api.post(
        `/${this._apiBaseURL}/send-change-password-link`,
        params
      )
    ).data;
    return response;
  }

  @action.bound async SendChangePasswordVerificationCode(
    params: ChangePasswordRequestDto
  ) {
    const response: ServiceResult<SendChangePasswordVerificationCodeResponseDto> =
      await (
        await this.api.post(
          `/${this._apiBaseURL}/send-change-password-verification-code`,
          params
        )
      ).data;
    return response;
  }

  @action.bound async CheckChangePasswordVerificationCode(
    params: ChangePasswordRequestDto
  ) {
    const q = qs.stringify(params, {
      encodeValuesOnly: true,
      addQueryPrefix: true,
    });
    const response: ServiceResult = await (
      await this.api.get(
        `/${this._apiBaseURL}/check-change-password-verification-code${q}`
      )
    ).data;
    return response;
  }
}

export default AccountActionStore;
